import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import warning from "./warning.jpg";
import logo from './../rcrm_logo.png';
import './FullScreenAlert.css';

const FullScreenAlert = (props) => {
  const history = useHistory();
  var elem = document.documentElement;

  function back2exam() {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
    // Get the exam code from sessionStorage and redirect to the correct dynamic exam route
    const examCode = sessionStorage.getItem("examcode");
    if (examCode) {
      history.push(`/dynamic-exam/${examCode}`);
    } else {
      // Fallback to formvalid if no exam code found
      history.push("/formvalid");
    }
  }

  // Timer logic
  const { initialMinute = sessionStorage.getItem("exam_timer"), initialSeconds = sessionStorage.getItem("exam_sec") || 0 } = props;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
        sessionStorage.setItem("exam_sec", seconds - 1);
      } else if (minutes > 0) {
        setMinutes(minutes - 1);
        setSeconds(59);
        sessionStorage.setItem("exam_timer", minutes - 1);
        sessionStorage.setItem("exam_sec", 59);
      } else {
        // Timer is up - prevent negative values and auto-submit
        clearInterval(myInterval);
        sessionStorage.setItem("exam_timer", 0);
        sessionStorage.setItem("exam_sec", 0);
        
        // Try to trigger auto-submit by dispatching a custom event
        window.dispatchEvent(new CustomEvent('examTimeUp'));
        
        // Wait a bit for the event to be processed, then redirect
        setTimeout(() => {
          // Check if we're still on the same page (event wasn't handled)
          // If the exam screen handled it, it would have redirected already
          history.push('/thankyou');
        }, 1000);
      }
    }, 1000);

    return () => clearInterval(myInterval);
  }, [minutes, seconds, history]);

  return (
    <div className="App">
      <img src={logo} alt="logo" className="App-logo" />
        <div className="fullscreen-alert">
          <div className="alert-card">
            <img src={warning} alt="Warning" className="warning-icon" />
            <h3 className="alert-title">SINCE YOU ESCAPED FULLSCREEN, YOUR ANSWERS ARE LOST!!</h3>
            <small className="alert-message">Action has been recorded!</small>
            <p className="alert-warning"><i>Another attempt to do so will get you debarred from the test.</i></p>
            <Button variant='contained' color='secondary' onClick={back2exam} className="back-button">
              I Understand, Get Me Back to Exam
            </Button>
          </div>
        </div>
    </div>
  );
};

export default FullScreenAlert;
